import { graphql, useStaticQuery } from 'gatsby';

export const useActiveEnv = (): string => {
  const data = useStaticQuery(
    graphql`
      {
        site {
          siteMetadata {
            activeEnv
          }
        }
      }
    `
  );
  return data.site.siteMetadata.activeEnv;
};
